import React from "react";

export default function Footer() {
  return (
    <p>
      <a
        href="https://github.com/mejkyss/weather-app-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open-source code
      </a>{" "}
      by Markéta Dokoupilová, hosted on{" "}
      <a
        href="https://gleaming-torrone-74f51e.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Netlify
      </a>
    </p>
  );
}
